import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class OrderOpinionComponent extends Vue {
    @Prop()
    reservationInfo: api.ReservationInfo;

    @Prop()
    page: string;

    items: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    view: string = 'form';

    onVote(item: number) {
        this.view = 'thanks';

        new api.ReservationService().saveOpinion({ reservationPublicId: this.reservationInfo.reservationPublicId, opinion:item }).then(
            () => {
                const gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

                gaParams.metric3 = this.reservationInfo.passengers.length;
                gaParams.metric8 = item;

                (<any>this).$ga.sendEvent('order.' + this.page, 'btn.opinion', 'order.' + this.page + '.btn.opinion', gaParams);
            },
            () => {
                // Do nothing
            }
        );
    }
}
